<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'「萌趣双星，梦幻同行」联动专题页上线'"></div>
    <div class="home-wrapper-3">
      <Header
        :isOnline="1"
        :config="headerConfig"
        :isShowInfo="true"
        :isShowDownLoad="true"
      />
      <div class="sanliouLinkage-home-page" id="sanliouLinkage-home-page">
        <div class="container">
          <div class="swiper-bg-warp">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="content-box">
                  <div class="logo"></div>
                  <div class="slogan"></div>
                  <div class="arrows" @click="nextPage"></div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="first-act-box">
                  <div class="title"></div>
                  <div class="wrap">
                    <div :class="'btn_bg' + photoBtn">
                      <div
                        :class="photoBtn == 1 ? 'all_checked' : 'all'"
                        @click="switchBtnClick(1)"
                      ></div>
                      <div
                        :class="
                          photoBtn == 2 ? 'collected_checked' : 'collected'
                        "
                        @click="switchBtnClick(2)"
                      ></div>
                      <div
                        :class="
                          photoBtn == 3 ? 'uncollected_checked' : 'uncollected'
                        "
                        @click="switchBtnClick(3)"
                      ></div>
                    </div>
                    <div class="photo_wrap">
                      <div
                        class="photoItem"
                        :key="item.card_id"
                        v-for="item in photoList"
                        @click="photoItemClick(item.card_id)"
                      >
                        <img
                          :class="unauthorizedClass(item.card_id) ? 'gray' : ''"
                          :src="getImageSrc(item.card_id)"
                          alt=""
                        />
                        <div
                          class="restrict"
                          v-if="
                            item.card_id == 1 ||
                            item.card_id == 2 ||
                            item.card_id == 3
                          "
                        ></div>
                        <div
                          class="norestrict"
                          v-if="
                            unauthorizedClass(item.card_id) &&
                            (item.card_id == 1 ||
                              item.card_id == 2 ||
                              item.card_id == 3)
                          "
                        ></div>
                        <div
                          class="menban"
                          v-if="unauthorizedClass(item.card_id)"
                        ></div>
                      </div>
                      <!-- 全部收集完成 -->
                      <!-- <div
                        class="finishBg"
                        v-if="
                          user_activity.my_card_list &&
                          user_activity.my_card_list.length == 20
                        "
                      ></div>
                      <div
                        class="finish"
                        v-if="
                          user_activity.my_card_list &&
                          user_activity.my_card_list.length == 20
                        "
                      ></div> -->
                      <div class="prev" @click="pageChange('prev')"></div>
                      <div class="next" @click="pageChange('next')"></div>
                    </div>
                    <div class="photo_btn_wrap">
                      <div class="log" @click="photoLogShowFun"></div>
                      <div class="task" @click="taskShowFun"></div>
                    </div>
                    <div class="btn_wrap">
                      <div class="detail_btn" @click="rulesShow = true"></div>
                      <div class="page_bg">
                        <p>{{ page }}/{{ total }}<span>页</span></p>
                      </div>
                    </div>
                  </div>
                  <div class="arrows" @click="nextPage"></div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="second-act-box">
                  <div class="title"></div>
                  <div class="time"></div>
                  <div class="role_wrap">
                    <div :class="'role' + roleIcon"></div>
                    <div :class="'introduce' + roleIcon"></div>
                    <div class="icon_bg">
                      <div
                        :class="roleIcon == 1 ? 'icon1 scale13 ml20' : 'icon1'"
                        @click="changeRole(1)"
                      ></div>
                      <div
                        :class="roleIcon == 2 ? 'icon2 scale13 mr20' : 'icon2'"
                        @click="changeRole(2)"
                      ></div>
                    </div>
                  </div>
                  <div class="btn_wrap">
                    <div class="detail_btn" @click="rulesShow = true"></div>
                    <div class="album_btn" @click="albumBtnClick"></div>
                    <div class="cg_btn" @click="showCg"></div>
                  </div>
                  <div class="arrows" @click="nextPage"></div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="lottery-act-box">
                  <div class="title"></div>
                  <div
                    class="address"
                    @click="areaShow = true"
                    v-if="repairAddress"
                  ></div>
                  <div class="lottery_wrap">
                    <div class="xk"></div>
                    <div class="sudoku">
                      <div class="icon1">
                        <div class="active" v-if="currentPrize == 1"></div>
                      </div>
                      <div class="icon2">
                        <div class="active" v-if="currentPrize == 2"></div>
                      </div>
                      <div class="icon3">
                        <div class="active" v-if="currentPrize == 3"></div>
                      </div>
                      <div class="icon4">
                        <div class="active" v-if="currentPrize == 4"></div>
                      </div>
                      <div class="btn" @click="lotteryFun"></div>
                      <div class="icon5">
                        <div class="active" v-if="currentPrize == 5"></div>
                      </div>
                      <div class="icon6">
                        <div class="active" v-if="currentPrize == 6"></div>
                      </div>
                      <div class="icon7">
                        <div class="active" v-if="currentPrize == 7"></div>
                      </div>
                      <div class="icon8">
                        <div class="active" v-if="currentPrize == 8"></div>
                      </div>
                    </div>
                    <div class="count">
                      {{ user_activity.dice ? user_activity.dice : 0 }}
                    </div>
                  </div>
                  <div class="btn_wrap">
                    <div class="log" @click="lotteryLogShowFun"></div>
                    <div
                      class="detail_btn"
                      @click="lotteryRulesShow = true"
                    ></div>
                    <div class="album_btn" @click="albumBtnClick"></div>
                  </div>
                  <div class="arrows" @click="nextPage"></div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="third-act-box">
                  <div class="title"></div>
                  <div class="swiper-box">
                    <div class="game-swiper-container swiper-container">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide slide1">
                          <div class="info-img-box">
                            <img
                              src="../../../../assets/images/active/sakura/sanliouLinkage/third/1.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="swiper-slide slide2">
                          <div class="info-img-box">
                            <img
                              src="../../../../assets/images/active/sakura/sanliouLinkage/third/2.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="swiper-slide slide3">
                          <div class="info-img-box">
                            <img
                              src="../../../../assets/images/active/sakura/sanliouLinkage/third/3.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="swiper-slide slide4">
                          <div class="info-img-box">
                            <img
                              src="../../../../assets/images/active/sakura/sanliouLinkage/third/4.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="swiper-slide slide5">
                          <div class="info-img-box">
                            <img
                              src="../../../../assets/images/active/sakura/sanliouLinkage/third/5.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                      <div class="swiper-pagination game-pagination"></div>
                    </div>
                    <div class="swiper-button-prev game-button-prev"></div>
                    <div class="swiper-button-next game-button-next"></div>
                  </div>
                  <div class="btn_wrap">
                    <div class="detail_btn" @click="rulesShow = true"></div>
                    <div class="album_btn" @click="albumBtnClick"></div>
                  </div>
                </div>
              </div>
              <div class="swiper-slide foot-page">
                <Footer :gameName="gameName" />
              </div>
            </div>
          </div>
        </div>

        <!-- 提示弹窗 -->
        <div :class="'tips-wrap tips-wrap-' + tipsShow">
          <div :class="'show-' + tipsShow2">
            <p>{{ tips }}</p>
          </div>
        </div>

        <!-- loading弹窗 -->
        <div class="loading-wrap" v-show="loadingShow">
          <div class="title"></div>
          <div class="loading_num">loading&nbsp;{{ count }}%</div>
        </div>

        <!-- 照片详情弹窗 -->
        <transition enter-active-class="animated fadeIn" name="fade">
          <div class="photo_detail" v-if="photoDetailShow">
            <div class="back_btn" @click="photoDetailShow = false"></div>
            <div class="detail_wrap">
              <div class="bg"></div>
              <div class="photo" @click="cgShow = true">
                <img
                  :class="unauthorizedClass(photoDetailId) ? 'gray' : ''"
                  :src="getImageSrc(photoDetailId)"
                  alt=""
                />
                <div
                  class="restrict"
                  v-if="
                    photoDetailId == 1 ||
                    photoDetailId == 2 ||
                    photoDetailId == 3
                  "
                ></div>
                <div
                  class="norestrict"
                  v-if="
                    unauthorizedClass(photoDetailId) &&
                    (photoDetailId == 1 ||
                      photoDetailId == 2 ||
                      photoDetailId == 3)
                  "
                ></div>
                <div
                  class="menban"
                  v-if="unauthorizedClass(photoDetailId)"
                ></div>
              </div>
              <div class="save"></div>
              <div class="btn_wrap">
                <div
                  class="give"
                  @click="giveOrSwitchClick(photoDetailId, 1)"
                ></div>
                <div class="switch" @click="switchClick(photoDetailId)"></div>
                <div class="hope" @click="hopeClick(photoDetailId)"></div>
              </div>
              <div class="card_num" :key="photoDetailId">
                可供交换数量：{{ getNum(photoDetailId) }}
              </div>
            </div>
          </div>
        </transition>

        <!-- 照片交换选择弹窗 -->
        <transition enter-active-class="animated fadeIn" name="fade">
          <div class="photo_switch" v-if="photoSwitchShow">
            <div class="title"></div>
            <div class="back_btn" @click="photoSwitchShow = false"></div>
            <div class="detail_wrap">
              <div class="list">
                <div
                  class="item"
                  v-for="item in user_activity.not_has_card_list"
                  :key="item.card_id"
                  @click="activeIndex = item.card_id"
                >
                  <img :src="getImageSrc(item.card_id)" alt="" />
                  <div class="menban" v-if="activeIndex === item.card_id">
                    <div class="active"></div>
                  </div>
                </div>
              </div>
              <div class="arrows"></div>
              <div class="confirm" @click="photoSwitchShowFun"></div>
            </div>
          </div>
        </transition>

        <!-- 横屏查看照片弹窗 -->
        <transition enter-active-class="animated fadeIn" name="fade">
          <div class="cg_dialog" v-if="cgShow">
            <div class="cg">
              <img :src="getBigImageSrc(photoDetailId)" alt="" />
              <img
                :src="getSaveImageSrc(photoDetailId)"
                alt=""
                style="opacity: 0"
              />
            </div>
            <div class="back_btn" @click="cgShow = false"></div>
            <div class="save"></div>
          </div>
        </transition>

        <!-- 获得卡片弹窗 -->
        <div class="get-card-wrap popup_wrap1" v-if="getCardShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="get-card-box">
              <div class="close-bg" @click="getCardShow = false"></div>
              <div class="detail_wrap">
                <div class="title"></div>
                <div class="bg"></div>
                <img :src="getImageSrc(getCardIndex)" alt="" />
                <div class="tips"></div>
              </div>
            </div>
          </transition>
        </div>

        <!-- 交换卡片弹窗 -->
        <div class="switch-card-wrap popup_wrap1" v-if="switchCardShow">
          <div class="close-bg" @click="switchCardShow = false"></div>
          <div class="switch-card-box">
            <div class="title"></div>
            <div class="tips" v-html="switchCardTips()"></div>
            <div class="detail_wrap">
              <div class="have_img">
                <img :src="getImageSrc(photoDetailId)" alt="" />
              </div>
              <div class="switch"></div>
              <div
                class="switch_bg"
                v-if="activeIndex == 0"
                @click="photoSwitchShowClcik()"
              ></div>
              <div class="switch_img" v-else>
                <img
                  :src="getImageSrc(activeIndex)"
                  alt=""
                  @click="photoSwitchShowClcik()"
                />
              </div>
            </div>
            <div class="btn" @click="giveOrSwitchClick(photoDetailId, 2)"></div>
            <div class="num">可供交换数量：{{ getNum(photoDetailId) }}</div>
          </div>
        </div>

        <!-- 卡片生成code弹窗 -->
        <div class="card-code-wrap popup_wrap1" v-if="cardCodeShow">
          <div class="close-bg" @click="cardCodeShow = false"></div>
          <div class="card-code-box">
            <img :src="shareImg" alt="分享图片" />
            <div class="share_url">
              {{ shareLink }}
            </div>
            <div
              class="btn"
              id="clipboard-btn"
              @click="onCopy"
              :data-clipboard-text="shareText + operateText + shareLink"
            ></div>
            <div class="tips"></div>
          </div>
        </div>

        <!-- 交换卡片弹窗(别人发过来的链接) -->
        <div class="switch-card2-wrap popup_wrap1" v-if="switchCardShow2">
          <div class="close-bg" @click="switchCardShow2 = false"></div>
          <div class="switch-card2-box">
            <div class="title"></div>
            <div class="tips" v-html="switchCardShow2Tips"></div>
            <div class="detail_wrap">
              <div class="have_img">
                <img :src="getImageSrc(switchCardShow2Card1)" alt="" />
              </div>
              <div class="switch"></div>
              <div class="switch_img">
                <img :src="getImageSrc(switchCardShow2Card2)" alt="" />
              </div>
            </div>
            <div class="btn" @click="switchFromUrlClick"></div>
          </div>
        </div>

        <!-- 别人祈愿/赠送卡片弹窗(别人发过来的链接) -->
        <div class="hope-or-give-wrap popup_wrap1" v-if="hopeOrGiveShow">
          <div class="close-bg" @click="hopeOrGiveShow = false"></div>
          <div class="hope-or-give-box">
            <div :class="hopeOrGiveType == 1 ? 'title1' : 'title'"></div>
            <div class="tips" v-html="hopeOrGiveTips"></div>
            <div class="hope_or_give_img">
              <img :src="getImageSrc(hopeOrGiveCard)" alt="" />
            </div>
            <div class="confirm" @click="giveOrHopeClick()"></div>
          </div>
        </div>

        <!-- 抽中奖品弹窗 -->
        <div class="lottery-wrap popup_wrap1" v-if="lotteryShow">
          <div class="close-bg" @click="winningClose"></div>
          <div class="lottery-box">
            <div class="title"></div>
            <div class="tips">
              <p>恭喜您获得了{{ prizeName }},</p>
              <p v-if="isPrizeReal == 1">填写收货地址后我们会为您寄出奖品</p>
              <p v-if="isPrizeReal == 0">请前往游戏邮箱领取奖励</p>
            </div>
            <div class="lottery_img">
              <img :src="getPrizeImageSrc()" alt="" />
            </div>
            <div
              :class="isPrizeReal == 1 ? 'btn' : 'confirm'"
              @click="winningClick"
            ></div>
          </div>
        </div>

        <!-- 地址填写弹窗 -->
        <div class="area-wrap popup_wrap1" v-if="areaShow">
          <div class="close-bg"></div>
          <div class="area-box">
            <div class="title"></div>
            <div class="content">
              <div class="area">
                <input
                  type="text"
                  v-model="area"
                  placeholder="请输入详细地址"
                />
              </div>
              <div class="number">
                <input
                  type="text"
                  v-model="number"
                  placeholder="请输入门牌号"
                />
              </div>
              <div class="name">
                <input type="text" v-model="name" placeholder="请输入联系人" />
              </div>
              <div class="phone">
                <input type="text" v-model="phone" placeholder="请输入手机号" />
              </div>
            </div>
            <div class="confirm" @click="addressFun"></div>
          </div>
        </div>

        <!-- 填写成功弹窗 -->
        <div class="fill-wrap popup_wrap1" v-if="fillShow">
          <div class="close-bg" @click="fillShow = false"></div>
          <div class="fill-box">
            <div class="title"></div>
            <div class="fill_img"></div>
            <div class="btn" @click="fillShow = false"></div>
            <div class="tips"></div>
          </div>
        </div>

        <!-- 活动详情弹窗 -->
        <div class="rules-wrap popup_wrap1" v-show="rulesShow">
          <div class="close-bg" @click="rulesShow = false"></div>
          <div class="rules-box">
            <div class="title"></div>
            <div class="content">
              <img
                src="../../../../assets/images/active/sakura/sanliouLinkage/dialog/rules/content.png"
                alt="活动规则"
              />
            </div>
            <div class="arrows"></div>
          </div>
        </div>

        <!-- 抽奖活动详情弹窗 -->
        <div class="lottery-rules-wrap popup_wrap1" v-show="lotteryRulesShow">
          <div class="close-bg" @click="lotteryRulesShow = false"></div>
          <div class="lottery-rules-box">
            <div class="title"></div>
            <div class="content">
              <img
                src="../../../../assets/images/active/sakura/sanliouLinkage/lottery/detail/content.png"
                alt="活动规则"
              />
            </div>
            <div class="arrows"></div>
            <div class="tips"></div>
          </div>
        </div>

        <!-- 照片获取记录弹窗 -->
        <div class="photo-log-wrap popup_wrap1" v-if="photoLogShow">
          <div class="close-bg" @click="photoLogShow = false"></div>
          <div class="photo-log-box">
            <div class="title"></div>
            <div class="line"></div>
            <div class="content">
              <div
                class="logItem"
                v-for="(item, index) in user_activity.record_list"
                :key="index"
              >
                <div class="time">{{ item.create_at }}</div>
                <div class="log">
                  <p v-for="(remarkItem, index) in item.remark" :key="index">
                    {{ remarkItem.type == 4 ? "与" : ""
                    }}{{ remarkItem.task_name
                    }}{{
                      remarkItem.type == 4
                        ? "交换"
                        : remarkItem.type == 3
                        ? "赠送"
                        : ""
                    }}
                    获得了 {{ remarkItem.remark }}
                  </p>
                </div>
              </div>
            </div>
            <div class="arrows"></div>
          </div>
        </div>

        <!-- 抽奖记录弹窗 -->
        <div class="lottery-log-wrap popup_wrap1" v-if="lotteryLogShow">
          <div class="close-bg" @click="lotteryLogShow = false"></div>
          <div class="lottery-log-box">
            <div class="title"></div>
            <div class="line"></div>
            <div class="content">
              <div
                class="logItem"
                v-for="(item, index) in user_activity.lottery_list"
                :key="index"
              >
                <div class="time">{{ item.created_at.split(" ")[0] }}</div>
                <div class="log">
                  <p>{{ item.created_at }} {{ item.remark }}</p>
                </div>
              </div>
            </div>
            <div class="arrows"></div>
            <div class="tips"></div>
          </div>
        </div>

        <!-- 任务弹窗 -->
        <div class="task-wrap popup_wrap1" v-if="taskShow">
          <div class="close-bg" @click="taskShow = false"></div>
          <div class="task-box">
            <div class="title"></div>
            <div class="content">
              <div class="mt"></div>
              <div
                :class="taskGetState(item.id) ? 'taskItem active' : 'taskItem'"
                v-for="item in taskList"
                :key="item.remake"
              >
                <div class="remake">{{ item.remake }}</div>
                <div class="award">{{ item.award }}</div>
                <div
                  :class="taskGetState(item.id) ? 'get' : 'go'"
                  @click="doneTask(item)"
                ></div>
              </div>
              <div class="mt"></div>
              <div
                :class="
                  cjTaskGetState(item.package_id)
                    ? 'taskItem gray taskItem' + index
                    : 'taskItem taskItem' + index
                "
                v-for="(item, index) in cjTaskList"
                :key="item.package_id"
                @click="bindRole(index)"
              >
                <div class="remake">{{ item.remake }}</div>
                <div
                  :class="
                    index == 1 || index == 4 || index == 5 ? 'award1' : 'award'
                  "
                  v-html="item.award"
                ></div>
                <div class="icon1" v-if="index == 0"></div>
                <div class="icon2" v-if="index == 1"></div>
                <div class="icon3" v-if="index == 1"></div>
                <div class="icon4" v-if="index == 2"></div>
                <div class="icon5" v-if="index == 3"></div>
                <div class="icon6" v-if="index == 4"></div>
                <div
                  :class="index == 1 || index == 5 ? 'icon7 mt100' : 'icon7'"
                  v-if="index == 0 || index == 1 || index == 5"
                ></div>
                <div class="icon8" v-if="index == 5"></div>
                <div class="icon9" v-if="index == 4"></div>
                <div class="icon10" v-if="index == 5"></div>
              </div>
              <div class="title1"></div>
              <div class="title2"></div>
            </div>
            <div class="arrows"></div>
            <div
              class="btn"
              v-if="cjTaskBtnState()"
              @click="getReward(user_activity)"
            ></div>
          </div>
        </div>
      </div>

      <!-- 登陆模块 -->
      <Login
        v-if="isShowLogin"
        v-on:channelCallback="selectCallback"
        v-on:loginSuccess="selectCallback"
        :gameName="gameName"
        :loginTypes="loginTypes"
        downloadUrl="https://hjwq.qingcijoy.com/"
        channelTips="UID可在游戏中—设置—UID查看"
        noAuthLogin
        :autoOpenOS="false"
      ></Login>
      <Os
        v-if="isShowOs"
        v-on:selectCallback="selectCallback"
        v-on:logoutCallback="osCancell"
        :gameName="gameName"
        :isChannel="isChannel"
        :platform="platform"
        v-on:getSelectInfo="getSelectInfo"
      ></Os>

      <!-- 分享相关DOM -->
      <div class="share-box-sakura" ref="imageDom">
        <img
          src="../../../../assets/images/active/sakura/sanliouLinkage/dialog/switchCard/bg.png"
        />
        <div class="title"></div>
        <div class="tips" v-html="shareTips"></div>
        <div class="qrcode-box">
          <div id="qrcode" class="qrcode"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { Indicator } from "mint-ui";
import Os from "../os";
import Login from "../login";
import Footer from "@/components/Footer";
import Header from "../Header/index.vue";
import { headerConfig } from "../headerConfig";
import { mapState, mapMutations, mapActions } from "vuex";
import {
  onGetInitDataAPI,
  reward,
  generateCode,
  cherryStatus,
  receive,
  exchange,
  generateGave,
  lotteryApi,
  addressApi,
  secretFreeLoginApi,
} from "../api";
import { getTimeStamp, buriedLogger } from "@/utils/utils";
import { generateQRCode, generateCanvasImage } from "@/utils/share";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    Login,
    Os,
    Header,
    Footer,
  },
  data() {
    return {
      gameName: "sakura",
      headerConfig,
      logger: null,
      // 其他数据
      loginTypes: ["sms", "password", "channel"],
      user_activity: {},
      user_userInfo: {},
      shareImg: "",
      shareLink: "",
      // 复制分享链接的活动文本前缀
      shareText: "",
      textList: [
        "萌趣双星，梦幻同行，一起收藏友谊吧!",
        "收集友谊相册，赢锦鲤大奖，",
        "《魔卡少女樱：回忆钥匙》梦幻盲盒「游园庆典」即将开启，",
      ],
      // 操作文本
      operateText: "",
      // 分享弹窗提示语
      shareTips: "",
      swiper: null,
      // 提示语
      tips: "",
      // 提示显示1
      tipsShow: false,
      // 提示显示2
      tipsShow2: false,
      // 是否显示loading弹窗
      loadingShow: true,
      // loading百分比
      count: 0,
      // 照片分类 1是全部 2是已收集 3是未收集
      photoBtn: 1,
      // 第三屏角色icon
      roleIcon: 1,
      // 是否显示照片详情弹窗
      photoDetailShow: false,
      // 查看详情图片的编号
      photoDetailId: 0,
      // 交换图片详情弹窗
      photoSwitchShow: false,
      // 横屏查看照片弹窗
      cgShow: false,
      // 选中的卡牌
      activeIndex: 0,
      // 获取卡片弹窗
      getCardShow: false,
      // 获得卡牌的id
      getCardIndex: 0,
      // 交换卡片弹窗
      switchCardShow: false,
      // 卡片生成code弹窗
      cardCodeShow: false,
      // 交换卡片弹窗(别人发过来的链接)
      switchCardShow2: false,
      // 交换卡片提示(别人发过来的链接)
      switchCardShow2Tips: "",
      // 交换卡片提示(别人发过来的链接)
      switchCardShow2Card1: 1,
      // 交换卡片提示(别人发过来的链接)
      switchCardShow2Card2: 1,
      // 别人祈愿/赠送弹窗
      hopeOrGiveShow: false,
      // 别人祈愿/赠送提示语(别人发过来的链接)
      hopeOrGiveTips: "",
      // 别人祈愿/赠送类型(别人发过来的链接) 1是赠送  3是祈愿
      hopeOrGiveType: 1,
      // 别人祈愿/赠送的卡牌id(别人发过来的链接) 1是赠送  3是祈愿
      hopeOrGiveCard: 1,
      // 链接过来弹窗只弹一次(弹过不再弹，刷新才会弹)
      linkPop: false,
      // 抽奖奖品弹窗
      lotteryShow: false,
      // 地址填写弹窗
      areaShow: false,
      // 地址
      area: "",
      // 门牌号
      number: "",
      // 姓名
      name: "",
      // 手机
      phone: "",
      // 填写成功弹窗
      fillShow: false,
      // 活动详情弹窗
      rulesShow: false,
      // 抽奖规则弹窗
      lotteryRulesShow: false,
      // 照片记录弹窗
      photoLogShow: false,
      // 抽奖记录弹窗
      lotteryLogShow: false,
      // 任务弹窗
      taskShow: false,
      // 任务列表
      taskList: [
        { id: 1, remake: "每日登录活动", award: "未收集照片*1" },
        {
          id: 2,
          remake: "每日赠送/交换一次照片",
          award: "随机照片*1  抽奖机会*1",
        },
        {
          id: 3,
          remake: "关注企微",
          award: "未收集照片*1",
          link: "",
        },
      ],
      // 成就任务列表
      cjTaskList: [
        {
          id: 1,
          package_id: 0,
          remake: "绑定角色",
          award: "星之币*100  抽奖机会*1",
        },
        {
          id: 2,
          package_id: 131,
          remake: "收集5款照片",
          award: "A级出行券*2<br/>S级出行券*2<br/>抽奖机会*1",
        },
        {
          id: 3,
          package_id: 132,
          remake: "收集8款照片",
          award: "瞬时魔法沙漏·大*10",
        },
        {
          id: 4,
          package_id: 133,
          remake: "收集15款照片",
          award: "高级盲盒兑换券*5",
        },
        {
          id: 5,
          package_id: 142,
          remake: "收集20款照片",
          award: "梦幻盲盒兑换券*2<br/>抽奖机会*2",
        },
        {
          id: 6,
          package_id: 150,
          remake: "收集3张三丽鸥家族联动照片",
          award: "专属微章*1<br/>梦幻盲盒兑换券*1<br/>抽奖机会*1",
        },
      ],
      // 照片页码
      page: 1,
      // 照片总页数
      total: 5,
      // 照片列表
      photoList: [
        { card_id: 1, name: "繁樱绮梦", is_sign: 1 },
        { card_id: 2, name: "璀璨双星", is_sign: 1 },
        { card_id: 3, name: "梦羽奇境", is_sign: 1 },
        { card_id: 4, name: "透明之翼", is_sign: 0 },
      ],
      // 前往关注企微定时器
      loopInt: null,
      // 是否是渠道服
      isChannel: false,
      // 平台
      platform: "",
      // 是否正在抽奖
      isDrawing: false,
      // 抽到的奖品id
      currentPrize: null,
      // 获得的奖品名称
      prizeName: "",
      // 获得的奖品是否是实物
      isPrizeReal: 0,
      // 正在生成分享图片
      codeImgLoading: false,
      // 抽奖绑定的参数（防止任务有可领取的奖励领取到了）
      is_bind: 0,
      // 补写地址
      repairAddress: false,
    };
  },
  created() {
    if (!this.isMobile()) {
      window.location.href = `https://h5.qingcigame.com/sakura/sanliouLinkage/pc${getTimeStamp()}`;
      return;
    }
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    if (
      this.$route.query.game_id &&
      this.$route.query.role_id &&
      this.$route.query.token
    ) {
      this.secretFreeLoginFun();
    } else {
      this.getLoginContainer();
    }
    // 埋点
    const bl = buriedLogger("sakura", "小樱_三丽欧联动");
    this.logger = bl;
  },
  mounted() {
    // 初始化
    this.swiperInit();
    this.initGameSwiper();
    this.incrementTo100();
    this.$nextTick(() => {
      this.isSetShare();
    });
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.account) {
          // TAG: 注销的时候
          this.currentPrize = null;
          this.shareImg = "";
          this.taskShow = false;
          this.photoDetailShow = false;
          this.repairAddress = false;
          if (this.swiper) {
            this.swiper.slideTo(0);
            this.user_activity = {};
            this.total = 5;
            this.photoListFun();
          }
          this.photoBtn = 1;
          this.page = 1;
        } else if (newValue.account !== oldValue.account) {
          // TAG: 初始登陆/切换角色的时候
          const { protocol, host } = window.location;
          this.shareLink = `${protocol}//${host}/sakura/sanliouLinkage/enter${getTimeStamp()}`;
          this.photoBtn = 1;
          this.page = 1;
          window.setTimeout(() => {
            this.initShareData();
            this.switchBtnClick(1);
          }, 500);
        }
      },
    },
  },
  methods: {
    // 判断是否是移动端
    isMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // 检查常见的移动设备标识符
      return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(
        userAgent
      );
    },
    incrementTo100() {
      const target = 100;
      const duration = 1000; // 持续时间1秒
      const stepTime = duration / target; // 每一步的时间间隔
      const that = this;
      const intervalId = setInterval(() => {
        that.count += 1;
        if (that.count >= target) {
          this.loadingShow = false;
          if (!this.user_userInfo.account) {
            this.changeLoginPopup(true);
          }
          clearInterval(intervalId); // 当达到100时停止计时器
        }
      }, stepTime);
    },
    // 初始化整体活动swiper
    swiperInit() {
      this.swiper = new Swiper(".swiper-bg-warp", {
        effect: "slide",
        direction: "vertical",
        slidesPerView: "auto",
        spaceBetween: 0,
        mousewheelControl: true,
        resistanceRatio: 0,
        initialSlide: 0,
      });
    },
    // 初始化第三屏swiper
    initGameSwiper() {
      new Swiper(".game-swiper-container.swiper-container", {
        direction: "horizontal",
        slidesPerView: "auto",
        spaceBetween: 0,
        initialSlide: 0,
        loop: true,
        centeredSlides: true,
        paginationClickable: true,
        pagination: ".game-pagination.swiper-pagination",
        nextButton: ".game-button-next.swiper-button-next",
        prevButton: ".game-button-prev.swiper-button-prev",
        effect: "coverflow",
        coverflow: {
          rotate: 5,
          stretch: 27,
          depth: 30,
          modifier: 6,
          slideShadows: false,
        },
      });
    },
    // 下一页
    nextPage() {
      this.swiper.slideNext();
    },
    // 未登录时重新初始化照片列表
    photoListFun() {
      this.photoList = [
        { card_id: 1, name: "繁樱绮梦", is_sign: 1 },
        { card_id: 2, name: "璀璨双星", is_sign: 1 },
        { card_id: 3, name: "梦羽奇境", is_sign: 1 },
        { card_id: 4, name: "透明之翼", is_sign: 0 },
      ];
    },
    // 初始化
    getLoginContainer() {
      onGetInitDataAPI({
        access_token: localStorage.getItem("access_token") || "",
      }).then((response) => {
        if (Number(response.code) == 200) {
          this.user_activity = response.data.activity;
          this.user_userInfo = response.data.user_info;
          this.onInitDataCallback(response);
          this.setUserInfo(response.data.user_info);
          this.taskList[2].link = response.data.activity.task_info[2].link;
          if (
            response.data.activity.good_record.length > 0 &&
            response.data.activity.good_record[0].address == ""
          ) {
            this.repairAddress = true;
          } else {
            this.repairAddress = false;
          }
          if (this.user_activity.task_info[2]._get == true) {
            console.log("清除定时器");
            clearInterval(this.loopInt);
          }
          if (
            !this.linkPop &&
            this.$route.query.type &&
            this.$route.query.card_id
          ) {
            this.linkPop = true;
            this.cherryStatusApi();
          }
          return;
        }
        // 登录异常
        if (Number(response.code) == 401 && response.data.info) {
          this.onInitDataCallback({});
          this.tipsMessage("信息加载失败，请先登入游戏", 2000);
          return;
        }
        // 请登录
        if (Number(response.code) == 401) {
          this.onInitDataCallback({});
          return;
        }
      });
    },
    // 绑定角色
    bindRole(index) {
      if (index != 0) {
        return;
      }
      if (!this.user_activity.role_name) {
        this.is_bind = 1;
        return this.getReward(this.user_activity);
      }
    },
    // 领取奖励
    getReward(data) {
      if (!this.user_activity.role_name && !data.role_name) {
        if (
          this.user_activity.platform == "ios" ||
          this.user_activity.platform == "android"
        ) {
          this.isChannel = false;
        } else {
          this.platform = this.user_activity.platform;
          this.isChannel = true;
        }
        if (!this.userInfo.account) {
          return;
        }
        return this.changeOsPopup(true);
      }
      let params = {
        role_id: data.role_id,
        role_name: data.role_name,
        server_id: data.server_id,
        platform: data.platform,
        server_name: data.server_name,
        extra: data.extra,
        game_id: data.game_id,
        token: data.token,
        is_bind: this.is_bind == 1 ? 1 : "",
      };
      reward({
        access_token: localStorage.getItem("access_token") || "",
        ...params,
      })
        .then((response) => {
          if (Number(response.code) == 200) {
            this.logger.sum("小樱_三丽欧联动_领取奖励");
            this.getLoginContainer();
            if (this.is_bind == 0) {
              this.tipsMessage("领取成功", 2000);
            }
          }
          this.is_bind = 0;
        })
        .finally(() => {
          Indicator.close();
        });
    },
    // 生成赠送/交换卡片
    generateCodeApi(card_id, type) {
      Indicator.open();
      this.shareText = this.textList[Math.floor(Math.random() * 3)];
      const { protocol, host } = window.location;
      const user_name = this.userInfo.account.substring(
        this.userInfo.account.length - 4
      );
      generateCode({
        access_token: localStorage.getItem("access_token") || "",
        card_id: card_id,
        type: type,
      }).then((response) => {
        if (Number(response.code) == 200) {
          setTimeout(() => {
            if (type == 1) {
              this.shareTips =
                "好友向你赠送<span>【" +
                this.getCardName(card_id) +
                "】</span><br />扫描二维码查看详情";
              this.shareLink = `${protocol}//${host}/sakura/sanliouLinkage/enter${getTimeStamp()}?from_id=${
                this.user_activity.user_id
              }&type=1&card_id=${card_id}&code=${
                response.data.data
              }&from_user=${user_name}`;
              this.operateText =
                "好友向你赠送【" + this.getCardName(card_id) + "】>>";
              this.logger.sum("小樱_三丽欧联动_发起赠送");
            } else if (type == 2) {
              this.shareTips =
                "好友想使用<span>【" +
                this.getCardName(card_id) +
                "】</span>交换<span>【" +
                this.getCardName(this.activeIndex) +
                "】</span><br />扫描二维码查看详情";
              this.shareLink = `${protocol}//${host}/sakura/sanliouLinkage/enter${getTimeStamp()}?from_id=${
                this.user_activity.user_id
              }&type=2&card_id=${card_id}&from_card_id=${
                this.activeIndex
              }&code=${response.data.data}&from_user=${user_name}`;
              this.operateText =
                "好友正在使用【" +
                this.getCardName(card_id) +
                "】交换【" +
                this.getCardName(this.activeIndex) +
                "】>>";
              this.logger.sum("小樱_三丽欧联动_发起交换");
            }
            this.qrcode(this.shareLink);
            this.$nextTick(() => {
              this.switchCardShow = false;
              this.activeIndex = 0;
              this.generateShareImage();
              this.codeImgLoading = true;
            });
          }, 50);
        } else {
          this.tipsMessage(response.message, 2000);
        }
      });
    },
    // 获取祈愿或者交换或者赠与链接状态
    cherryStatusApi() {
      const params = {
        access_token: localStorage.getItem("access_token") || "",
        code: this.$route.query.code,
        type: this.$route.query.type,
        from_id: this.$route.query.from_id,
        card_id: this.$route.query.card_id,
      };
      cherryStatus(params).then((response) => {
        if (Number(response.code) == 200) {
          if (!response.data.is_effect) {
            return this.tipsMessage("链接已失效", 2000);
          } else {
            switch (this.$route.query.type) {
              case "1":
                this.hopeOrGiveTips =
                  this.$route.query.from_user +
                  "向你赠送<span>【" +
                  this.getCardName(this.$route.query.card_id) +
                  "】</span>";
                this.hopeOrGiveType = 1;
                this.hopeOrGiveCard = this.$route.query.card_id;
                this.hopeOrGiveShow = true;
                break;
              case "2":
                this.switchCardShow2Tips =
                  this.$route.query.from_user +
                  "想使用<span>【" +
                  this.getCardName(this.$route.query.card_id) +
                  "】</span>交换<span>【" +
                  this.getCardName(this.$route.query.from_card_id) +
                  "】</span>是否确认与TA交换";
                this.switchCardShow2Card1 = this.$route.query.card_id;
                this.switchCardShow2Card2 = this.$route.query.from_card_id;
                this.switchCardShow2 = true;
                break;
              case "3":
                this.hopeOrGiveTips =
                  this.$route.query.from_user +
                  "向你祈愿<span>【" +
                  this.getCardName(this.$route.query.card_id) +
                  "】</span>是否确认赠送";
                this.hopeOrGiveType = 3;
                this.hopeOrGiveCard = this.$route.query.card_id;
                this.hopeOrGiveShow = true;
                break;
            }
          }
        } else {
          this.tipsMessage(response.message, 2000);
        }
      });
    },
    // 通过链接接受好友赠与或者赠送好友祈愿道具
    giveOrHopeClick() {
      if (this.hopeOrGiveType == 1) {
        this.receiveApi();
      } else {
        this.generateGaveApi();
      }
    },
    // 通过链接接受好友赠与或者赠送好友祈愿道具
    switchFromUrlClick() {
      this.exchangeApi();
    },
    // 通过链接接受好友赠送的道具
    receiveApi() {
      receive({
        access_token: localStorage.getItem("access_token") || "",
        code: this.$route.query.code,
      }).then((response) => {
        if (Number(response.code) == 200) {
          this.logger.sum("小樱_三丽欧联动_通过链接接受好友赠送的道具");
          this.getLoginContainer();
          this.hopeOrGiveShow = false;
          this.getCardIndex = this.$route.query.card_id;
          this.getCardShow = true;
        }
        this.tipsMessage(response.message, 2000);
      });
    },
    // 通过链接接受好友交换卡片
    exchangeApi() {
      exchange({
        access_token: localStorage.getItem("access_token") || "",
        card_id: this.$route.query.from_card_id,
        code: this.$route.query.code,
      }).then((response) => {
        if (Number(response.code) == 200) {
          this.logger.sum("小樱_三丽欧联动_通过链接接受好友交换卡片");
          this.getLoginContainer();
          this.switchCardShow2 = false;
          this.getCardIndex = this.$route.query.card_id;
          this.getCardShow = true;
        }
        this.tipsMessage(response.message, 2000);
      });
    },
    // 通过链接接受好友祈愿赠与道具
    generateGaveApi() {
      generateGave({
        access_token: localStorage.getItem("access_token") || "",
        card_id: this.$route.query.card_id,
        from_id: this.$route.query.from_id,
      }).then((response) => {
        if (Number(response.code) == 200) {
          this.logger.sum("小樱_三丽欧联动_通过链接接受好友祈愿赠与道具");
          this.getLoginContainer();
          this.hopeOrGiveShow = false;
        }
        this.tipsMessage(response.message, 2000);
      });
    },
    // 抽奖
    lotteryFun() {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true);
      }
      if (this.user_activity.dice == 0) {
        return this.tipsMessage(
          "您没有抽奖次数了，请完成任务获取抽奖次数~",
          2000
        );
      }
      if (!this.user_activity.role_name) {
        this.is_bind = 1;
        return this.getReward(this.user_activity);
      }
      if (this.isDrawing) return;
      this.isDrawing = true;
      lotteryApi({
        access_token: localStorage.getItem("access_token") || "",
      }).then((response) => {
        if (Number(response.code) == 200) {
          this.logger.sum("小樱_三丽欧联动_抽奖");
          this.getLoginContainer();
          let index = 0; // 转动的index
          const totalPrizes = 8; // 礼品个数
          const randomPrizeIndex = response.data.id - 1;
          const interval = setInterval(() => {
            this.currentPrize = (index % totalPrizes) + 1; // +1是因为求余会得0，但是礼品id是从1开始
            index++;
            if (index > randomPrizeIndex + totalPrizes * 3) {
              // 让转盘多转几圈
              clearInterval(interval);
              this.isDrawing = false;
              this.prizeName = response.data.title;
              this.isPrizeReal = response.data.is_good;
              this.lotteryShow = true;
            }
          }, 150);
        } else {
          this.isDrawing = false;
          this.tipsMessage(response.message, 2000);
        }
      });
    },
    // 获取奖品图片src
    getPrizeImageSrc() {
      return require(`@/assets/images/active/sakura/sanliouLinkage/lottery/winning/icon${this.currentPrize}.png`);
    },
    // 中奖操作
    winningClick() {
      this.lotteryShow = false;
      if (this.isPrizeReal == 1) {
        this.areaShow = true;
      }
    },
    // 中奖蒙版层
    winningClose() {
      if (this.isPrizeReal == 0) {
        this.lotteryShow = false;
      }
    },
    // 填写收货地址
    addressFun() {
      if (!this.name || !this.phone || !this.area || !this.number) {
        this.tipsMessage("请填写完整信息", 2000);
        return;
      }
      addressApi({
        access_token: localStorage.getItem("access_token") || "",
        name: this.name,
        phone: this.phone,
        address: this.area + this.number,
      }).then((response) => {
        if (Number(response.code) == 200) {
          this.logger.sum("小樱_三丽欧联动_填写收货地址");
          this.getLoginContainer();
          this.areaShow = false;
          this.tipsMessage("填写成功", 2000);
        } else {
          this.tipsMessage(response.message, 2000);
        }
      });
    },
    // 免密登录
    secretFreeLoginFun() {
      const params = {
        game_id: this.$route.query.game_id,
        role_id: this.$route.query.role_id,
        sign: this.$route.query.sign,
        token: this.$route.query.token,
      };
      secretFreeLoginApi(params).then((response) => {
        if (Number(response.code) == 200) {
          localStorage.setItem("access_token", response.data.access_token);
          this.getLoginContainer();
          this.logger.sum("小樱_三丽欧联动_免密登录成功");
        } else {
          this.logger.sum("小樱_三丽欧联动_免密登录失败");
          this.tipsMessage(response.message, 2000);
        }
      });
    },
    // 打开照片记录弹窗
    photoLogShowFun() {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true);
      }
      this.logger.sum("小樱_三丽欧联动_打开照片记录弹窗");
      this.photoLogShow = true;
    },
    // 打开任务弹窗
    taskShowFun() {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true);
      }
      this.logger.sum("小樱_三丽欧联动_打开任务弹窗");
      this.taskShow = true;
    },
    doneTask(item) {
      const that = this;
      if (item._get) {
        return;
      }
      if (item.id == 1) {
        return;
      }
      if (item.id == 2) {
        that.logger.sum("小樱_三丽欧联动_任务2");
        return this.tipsMessage("请前往交换卡片", 2000);
      }
      if (item.id == 3) {
        this.logger.sum("小樱_三丽欧联动_点击前往小程序wiki");
        document.onvisibilitychange = function () {
          if (document.visibilityState == "visible") {
            that.logger.sum("小樱_三丽欧联动_小程序返回活动页");
            console.log("切回应用");
            that.getLoginContainer();
            that.loopInt = setInterval(function () {
              console.log("检测是否返回应用");
              that.getLoginContainer();
            }, 1000);
            setTimeout(function () {
              console.log("清除定时器");
              clearInterval(that.loopInt);
            }, 15000);
          }
        };
        window.location.href = item.link;
      }
    },
    // 获取任务状态
    taskGetState(id) {
      if (!this.user_activity.task_info) {
        return false;
      }
      for (let i = 0; i < this.user_activity.task_info.length; i++) {
        if (this.user_activity.task_info[i].id == id) {
          return this.user_activity.task_info[i]._get;
        }
      }
    },
    // 获取成就任务状态
    cjTaskGetState(package_id) {
      if (!this.user_activity.reward_list) {
        return false;
      }
      if (package_id == 0) {
        if (this.user_activity.is_bind == 1) {
          return true;
        } else {
          return false;
        }
      }
      for (let i = 0; i < this.user_activity.reward_list.data.length; i++) {
        if (this.user_activity.reward_list.data[i].package_id == package_id) {
          return this.user_activity.reward_list.data[i].is_get;
        }
      }
    },
    // 获取成就任务一键领取按钮状态
    cjTaskBtnState() {
      if (!this.user_activity.reward_list) {
        return false;
      }
      // const isShow = this.user_activity.reward_list.data.some(
      //   task => task._get === true && task.is_get === false
      // );
      const isShow = this.user_activity.reward_list.number > 0;
      if (this.user_activity.is_bind == 0) {
        return true;
      }
      return isShow;
    },
    // 选择角色然后领奖
    getSelectInfo(response) {
      this.getReward(response);
    },
    // 打开抽奖记录弹窗
    lotteryLogShowFun() {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true);
      }
      if (this.user_activity.lottery_list.length == 0) {
        return this.tipsMessage("暂无抽奖记录", 2000);
      }
      this.logger.sum("小樱_三丽欧联动_打开抽奖记录");
      this.lotteryLogShow = true;
    },
    // 进入图片详情
    photoItemClick(card_id) {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true);
      }
      this.activeIndex = 0;
      this.photoDetailId = card_id;
      this.photoDetailShow = true;
    },
    // 获取可交换的数量
    getNum(card_id) {
      if (
        !this.user_activity.my_card_list.some((card) => card_id == card.card_id)
      ) {
        return 0;
      }
      for (let i = 0; i < this.user_activity.my_card_list.length; i++) {
        if (this.user_activity.my_card_list[i].card_id == card_id) {
          return this.user_activity.my_card_list[i].num - 1;
        }
      }
    },
    // 自己点击赠送或者交换
    giveOrSwitchClick(card_id, type) {
      if (this.getNum(card_id) == 0) {
        return this.tipsMessage(
          "您未拥有多余照片，快用其他照片和好友交换吧",
          2000
        );
      }
      if (type == 2) {
        if (this.activeIndex == 0) {
          return this.tipsMessage("请选择一张未收集的照片交换", 2000);
        }
      }
      this.generateCodeApi(card_id, type);
    },
    // 自己点击点击交换按钮
    switchClick(card_id) {
      if (this.getNum(card_id) == 0) {
        return this.tipsMessage(
          "您未拥有多余照片，快用其他照片和好友交换吧",
          2000
        );
      }
      this.switchCardShow = true;
    },
    // 获取卡牌名称
    getCardName(card_id) {
      for (let i = 0; i < this.user_activity.all_card_list.length; i++) {
        if (this.user_activity.all_card_list[i].card_id == card_id) {
          return this.user_activity.all_card_list[i].name;
        }
      }
    },
    // 自己点击祈愿
    hopeClick(card_id) {
      Indicator.open();
      this.shareText = this.textList[Math.floor(Math.random() * 3)];
      this.shareTips =
        "好友向你祈愿<span>【" +
        this.getCardName(card_id) +
        "】</span><br />扫描二维码查看详情";
      const user_name = this.userInfo.account.substring(
        this.userInfo.account.length - 4
      );
      const { protocol, host } = window.location;
      this.shareLink = `${protocol}//${host}/sakura/sanliouLinkage/enter${getTimeStamp()}?from_id=${
        this.user_activity.user_id
      }&type=3&card_id=${card_id}&from_user=${user_name}`;
      this.operateText = "好友向你祈愿【" + this.getCardName(card_id) + "】>>";
      this.logger.sum("小樱_三丽欧联动_生成祈愿链接");
      setTimeout(() => {
        this.qrcode(this.shareLink);
        this.$nextTick(() => {
          this.generateShareImage();
          this.codeImgLoading = true;
        });
      }, 50);
    },
    // 切换相册
    switchBtnClick(type) {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true);
      }
      this.photoBtn = type;
      this.page = 1;
      switch (this.photoBtn) {
        case 1:
          this.total = 5;
          this.photoList = this.user_activity.all_card_list.slice(0, 4);
          break;
        case 2:
          this.total = Math.ceil(this.user_activity.my_card_list.length / 4);
          this.photoList = this.user_activity.my_card_list.slice(0, 4);
          break;
        case 3:
          this.total = Math.ceil(
            this.user_activity.not_has_card_list.length / 4
          );
          this.photoList = this.user_activity.not_has_card_list.slice(0, 4);
          break;
      }
    },
    // 变更照片页码和照片列表
    pageChange(type) {
      if (!this.userInfo.account) {
        return this.changeLoginPopup(true);
      }
      if (type === "prev") {
        if (this.page > 1) {
          this.page--;
        }
      } else {
        if (this.photoBtn == 1 && this.page < 5) {
          this.page++;
        }
        if (
          this.photoBtn == 2 &&
          this.page < Math.ceil(this.user_activity.my_card_list.length / 4)
        ) {
          this.page++;
        }
        if (
          this.photoBtn == 3 &&
          this.page < Math.ceil(this.user_activity.not_has_card_list.length / 4)
        ) {
          this.page++;
        }
      }
      switch (this.photoBtn) {
        case 1:
          this.photoList = this.user_activity.all_card_list.slice(
            (this.page - 1) * 4,
            this.page * 4
          );
          break;
        case 2:
          this.photoList = this.user_activity.my_card_list.slice(
            (this.page - 1) * 4,
            this.page * 4
          );
          break;
        case 3:
          this.photoList = this.user_activity.not_has_card_list.slice(
            (this.page - 1) * 4,
            this.page * 4
          );
          break;
      }
    },
    // 判断卡牌是否未拥有
    unauthorizedClass(card_id) {
      if (!this.user_activity.my_card_list) {
        return true;
      }
      for (let i = 0; i < this.user_activity.not_has_card_list.length; i++) {
        if (this.user_activity.not_has_card_list[i].card_id == card_id) {
          return true;
        }
      }
    },
    // 点击回忆相册按钮
    albumBtnClick() {
      this.swiper.slideTo(1);
    },
    // 获取图片src
    getImageSrc(index) {
      return `https://download4.qcplay.com/pic/card/${index}.png`;
    },
    // 获取CG大图图片src
    getBigImageSrc(index) {
      return `https://download4.qcplay.com/pic/big/${index}.png`;
    },
    // 保存大图图片src
    getSaveImageSrc(index) {
      return `https://download4.qcplay.com/pic/saveCard/${index}.jpg`;
    },
    // 交换卡牌弹窗提示语
    switchCardTips() {
      if (this.activeIndex != 0) {
        return (
          "使用<span>【" +
          this.getCardName(this.photoDetailId) +
          "】</span>交换<span>【" +
          this.getCardName(this.activeIndex) +
          "】</span>"
        );
      } else {
        return "请选择一张未收集的照片交换";
      }
    },
    // 交换卡牌弹窗选择卡片 传2是进入别人发的交换链接
    photoSwitchShowClcik() {
      this.switchCardShow = false;
      this.photoSwitchShow = true;
    },
    // 照片交换选择弹窗
    photoSwitchShowFun() {
      this.photoSwitchShow = false;
      this.switchCardShow = true;
    },
    // 改变第三屏角色
    changeRole(type) {
      this.roleIcon = type;
    },
    // 查看第三屏角色cg
    showCg() {
      this.photoDetailId = this.roleIcon + 1;
      this.cgShow = true;
    },
    // 初始化分享信息
    initShareData(info) {
      try {
        this.qrcode(this.shareLink);
        this.$nextTick(() => {
          this.generateShareImage();
        });
      } catch (err) {
        // 错误信息
        console.log("err", err);
      }
    },
    qrcode(link) {
      generateQRCode(document.getElementById("qrcode"), {
        text: link,
        colorDark: "#ff99c2",
      });
    },
    // 分享图片设置
    generateShareImage() {
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          this.shareImg = canvas.toDataURL("image/png"); // 可将 canvas 转为 base64 格式
          console.log("success: 图片生成成功", canvas);
          if (this.codeImgLoading) {
            this.cardCodeShow = true;
            this.codeImgLoading = false;
          }
        })
        .catch((err) => {
          console.log("err: 图片生成失败", err.message);
        })
        .finally(() => {
          Indicator.close();
        });
    },
    // 复制链接
    onCopy() {
      const clipboard = new Clipboard("#clipboard-btn");
      clipboard.on("success", (e) => {
        this.tipsMessage("已成功复制分享链接", 2000);
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.tipsMessage("复制失败", 2000);
      });
      this.logger.sum("小樱_三丽欧联动_复制链接按钮");
    },
    selectCallback() {
      this.getLoginContainer();
    },
    osCancell() {
      // 清空数据
      this.getLoginContainer();
    },
    tipsMessage(message, times) {
      this.tipsShow = true;
      this.tips = message;
      setTimeout(() => {
        this.tipsShow2 = true;
      }, 100);
      setTimeout(() => {
        this.tipsShow2 = false;
      }, times - 200);
      setTimeout(() => {
        this.tipsShow = false;
        this.tips = "";
      }, times);
    },
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/sakura/sanliouLinkage/enter${getTimeStamp()}`,
        title: "「萌趣双星，梦幻同行」联动专题页上线",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/6EiJcJ1pE2qsdIMa041mlyludzgTjd55Cp3Q701s.jpeg",
        desc: "《魔卡少女樱：回忆钥匙》×《三丽鸥家族》可爱相遇收集友谊相册，参与精美周边抽奖！",
      });
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/sakura/sanliouLinkage/index/index.vue